<!--
  La densité d'une parcelle dans les tableaux repris du mail (densiteCell) :
  sur ses seuls avize pesés, avec la couverture dessous. Hors de l'intervalle
  plausible (550–1 550 kg/m³, envoyé par le serveur), c'est un lien de pesée
  faux : signalé « à vérifier ». Dedans, la couleur de Clément (29/10/2026) :
  sous 800 rouge, 800–900 orange, au-dessus de 900 vert — avec le mot à côté.
-->
<template>
  <div v-if="d !== null">
    <hv-pill v-if="odd" tone="warn" :label="`${int(d)} · à vérifier`" />
    <hv-pill v-else :tone="band.tone" :label="`${int(d)} · ${band.word}`" />
    <div class="hv2-cell-line">{{ int(p.avize_weighed) }} pesé(s) sur {{ int(p.avize) }}</div>
  </div>
  <span v-else class="hv2-muted">{{ DASH }}</span>
</template>

<script>
import fmt from '../format'
import HvPill from './HvPill'

export default {
  name: 'HvDensityCell',
  components: { HvPill },
  props: {
    p: { type: Object, default: null },
    min: { type: Number, default: 550 },
    max: { type: Number, default: 1550 }
  },
  computed: {
    DASH: () => fmt.DASH,
    d () {
      const d = this.p && this.p.density_kg_m3
      return d === null || d === undefined || !Number(this.p.avize_weighed) ? null : Number(d)
    },
    odd () { return this.d < this.min || this.d > this.max },
    band () {
      const shown = Math.round(this.d) // la bande suit le chiffre affiché
      if (shown < 800) return { tone: 'danger', word: 'faible' }
      if (shown <= 900) return { tone: 'warn', word: 'moyenne' }
      return { tone: 'ok', word: 'bonne' }
    }
  },
  methods: {
    int: fmt.int
  }
}
</script>
